import React from 'react'
import PropTypes from 'prop-types'

import { graphql, compose, withApollo } from 'react-apollo'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import LinearProgress from '@material-ui/core/LinearProgress'

import Upload from './components/Upload'
import { isMobile } from '../../utils'
import { GET_USER_AUTHENTICATED } from '../../graphql/queries'
import UploadDocument from './components/UploadDocument'
import { Centered } from './styles'

const HeroDocument = ({ data , me }) => {
  return (
    <React.Fragment>
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContent>
          {data.loading ? (
            <Centered>
              <LinearProgress />
            </Centered>
          ) : (
            <div>
              <Upload
                label="รูปโปรไฟล์"
                name="avatar"
                image={(data.me && data.me.avatar) || {}}
                me={me}/>
              {!data.loading &&
                data.me &&
                (data.me.heroType === 'RECYCLE_SHOP' ||
                  data.me.heroType === 'SCOOTER') && (
                  <Upload
                    label="รูปบัตรประชาชน"
                    name="idCard"
                    image={(data.me && data.me.idCard) || {}}
                    me={me}
                  />
                )}
              {!data.loading &&
                data.me &&
                (data.me.heroType === 'RECYCLE_SHOP' ||
                  data.me.heroType === 'SCOOTER' ||
                  data.me.heroType === 'POSTAL' ||
                  data.me.heroType === 'DROP_POINT') &&
                data.me.pictures &&
                data.me.pictures.length > 0 &&
                data.me.pictures.map((picture, index) => (
                  <UploadDocument
                    imageLength={data.me.pictures ? data.me.pictures.length : 0}
                    key={`picture-${picture.id}`}
                    label={`รูปหน้าร้าน / รูปรถ / สถานที่ตั้ง ${index + 1}`}
                    name="pictures"
                    image={picture || {}}
                    me={me}
                  />
                ))}
              <UploadDocument
                imageLength={data.me ? data.me.pictures.length : 0}
                label="รูปหน้าร้าน / รูปรถ / สถานที่ตั้ง"
                name="pictures"
                image={{}}
                me={me}
              />
            </div>
          )}
        </CardContent>
      </Card>
    </React.Fragment>
  )
}
HeroDocument.propTypes = {
  data: PropTypes.object.isRequired
}

export default compose(
  withApollo,
  graphql(GET_USER_AUTHENTICATED)
)(HeroDocument)



// WEBPACK FOOTER //
// ./src/components/HeroDocument/index.js